import { render, staticRenderFns } from "./SiteCard.vue?vue&type=template&id=2d0df08e&scoped=true"
import script from "./SiteCard.vue?vue&type=script&lang=js"
export * from "./SiteCard.vue?vue&type=script&lang=js"
import style0 from "./SiteCard.vue?vue&type=style&index=0&id=2d0df08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0df08e",
  null
  
)

export default component.exports